import { FC } from 'react';

import { COLORS } from '@/shared/constants/colors';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { DeactivateScenarioConfirmationModalProps } from '@/widgets/modals/types';

import { ScenarioConfirmationModal } from '../ScenarioActionConfirmationModalContainer';

export const DeactivateScenarioConfirmationModal: FC<DeactivateScenarioConfirmationModalProps> = ({
  onConfirm,
}) => {
  const { closeModal } = useModalsStore();

  const { t } = useTranslation('widgets/scenariosActions', {
    keyPrefix: 'deactivateScenarioConfirmationModal',
  });

  const onDeactivate = () => {
    onConfirm();
    closeModal();
  };

  return (
    <ScenarioConfirmationModal
      cancelButtonText={t('cancelButton')}
      content={t('content')}
      onClose={closeModal}
      onSubmit={onDeactivate}
      submitButtonText={t('submitButton')}
      title={t('title')}
      submitButtonStyle={{ backgroundColor: COLORS.systemFlame200, color: COLORS.systemLight100 }}
    />
  );
};
